import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MasterComponent } from 'ui-shared';
import { LoginComponent } from './features/compartilhado/login/login.component';
import { ClassificacaoFiscalConfigAuthGuard } from './features/compartilhado/login/classificacao-config-auth-guard';
import { ClassificacaoFiscalAuthGuard } from './features/compartilhado/login/classificacao-operacao-auth-guard';

const routes: Routes = [
    {
        path: 'config',
        component: MasterComponent,
        canActivate: [ClassificacaoFiscalConfigAuthGuard],
        children: [
            {
                path: 'home',
                loadChildren: () => import('./features/configuracao/home-config/home-config.module')
                    .then(m => m.HomeConfigModule)
            },
            {
                path: 'parametros',
                loadChildren: () => import('./features/configuracao/parametro-configuracao/parametro-configuracao.module')
                    .then(m => m.ParametroConfiguracaoModule)
            },
            {
                path: 'parametro-valor',
                loadChildren: () => import('./features/configuracao/parametro-valor/parametro-valor.module')
                    .then(m => m.ParametroValorModule)
            },
            {
                path: 'clientes',
                loadChildren: () => import('./features/configuracao/cliente/cliente.module')
                    .then(m => m.ClientesModule)
            },
            {
                path: 'notificacoes',
                loadChildren: () => import('./features/configuracao/notificacao/notificacao.module')
                    .then(m => m.NotificacaoModule)
            },
            {
                path: 'notificacoes-mensagens-agrupada',
                loadChildren: () => import('./features/compartilhado/notificacao-mensagem-agrupada/notificacao-mensagem-agrupada.module')
                    .then(m => m.NotificacaoMensagemAgrupadaModule)
            },
            {
                path: 'solicitacao-processamento',
                loadChildren: () => import('./features/configuracao/solicitacao-processamento/solicitacao-processamento.module')
                    .then(m => m.SolicitacaoProcessamentoModule)
            },
            {
                path: 'relatorios',
                loadChildren: () => import('./features/configuracao/relatorio/relatorio.module')
                    .then(m => m.RelatoriosModule)
            },
            {
                path: 'ncm',
                loadChildren: () => import('./features/compartilhado/ncm/ncm.module')
                    .then(m => m.NcmModule)
            },
            {
                path: 'ncm-manutencao',
                loadChildren: () => import('./features/configuracao/ncm-manutencao/ncm-manutencao.module')
                    .then(m => m.NcmManutencaoModule)
            },
            { path: '**', redirectTo: 'home' }

        ]
    },
    {
        path: '',
        component: MasterComponent,
        canActivate: [ClassificacaoFiscalAuthGuard],
        children: [
            {
                path: 'home',
                loadChildren: () => import('./features/operacional/home/home.module')
                    .then(m => m.HomeModule)
            },
            {
                path: 'usuario/configuracao',
                loadChildren: () => import('ui-shared').then(m => m.UsuarioConfiguracaoModule)
            },
            {
                path: 'gestao-usuario',
                loadChildren: () => import('./features/operacional/gestao-usuario/gestao-usuario.module')
                    .then(m => m.GestaoUsuarioModule)
            },
            {
                path: 'ncm',
                loadChildren: () => import('./features/compartilhado/ncm/ncm.module')
                    .then(m => m.NcmModule)
            },
            {
                path: 'produto',
                loadChildren: () => import('./features/operacional/produto/produto.module')
                    .then(m => m.ProdutoModule)
            },
            {
                path: 'classificacao',
                loadChildren: () => import('./features/operacional/classificacao/classificacao.module')
                    .then(m => m.ClassificacaoModule)
            },
            {
                path: 'projeto',
                loadChildren: () => import('./features/operacional/projeto/projeto.module')
                    .then(m => m.ProjetoModule)
            },
            {
                path: 'perfil-acesso',
                loadChildren: () => import('./features/operacional/perfil-acesso/perfil-acesso.module')
                    .then(m => m.PerfilAcessoModule)
            },
            {
                path: 'acao-status',
                loadChildren: () => import('./features/operacional/acao-status/acao-status.module')
                    .then(m => m.AcaoStatusModule)
            },
            {
                path: 'notificacoes-mensagens-agrupada',
                loadChildren: () => import('./features/compartilhado/notificacao-mensagem-agrupada/notificacao-mensagem-agrupada.module')
                    .then(m => m.NotificacaoMensagemAgrupadaModule)
            },
            {
                path: 'acesso-negado',
                loadChildren: () => import('./features/operacional/acesso-negado/acesso-negado.module')
                    .then(m => m.AcessoNegadoModule)
            },
            {
                path: 'historico-alteracoes',
                loadChildren: () => import('./features/operacional/historico-alteracoes/historico-alteracoes.module')
                    .then(m => m.HistoricoAlteracoesModule)
            },
            {
                path: 'importacao-dados',
                loadChildren: () => import('./features/operacional/importacao-dados/importacao-dados.module')
                    .then(m => m.ImportacaoDadosModule)
            },
            {
                path: 'relatorio',
                loadChildren: () => import('./features/operacional/relatorio/relatorio.module')
                    .then(m => m.RelatorioModule)
            },
            {
                path: 'parametro-operacao-valor',
                loadChildren: () => import('./features/operacional/parametro-operacao-valor/parametro-operacao-valor.module')
                    .then(m => m.ParametroOperacaoValorModule)
            },
            // {
            //     path: '',
            //     loadChildren: () => import('./features/operacional/home/home.module')
            //         .then(m => m.HomeModule)
            // }
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        pathMatch: 'full'
    },
    {
        path: '**', redirectTo: '/login'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
